var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4433_6194)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.89062 4.93978C1.89062 3.25254 3.2584 1.88477 4.94564 1.88477H11.0557C12.7429 1.88477 14.1107 3.25254 14.1107 4.93978V11.0498C14.1107 12.737 12.7429 14.1048 11.0557 14.1048H4.94564C3.2584 14.1048 1.89062 12.737 1.89062 11.0498V4.93978ZM4.94564 3.10677C3.9333 3.10677 3.11263 3.92744 3.11263 4.93978V11.0498C3.11263 12.0622 3.9333 12.8828 4.94564 12.8828H11.0557C12.068 12.8828 12.8887 12.0622 12.8887 11.0498V4.93978C12.8887 3.92744 12.068 3.10677 11.0557 3.10677H4.94564Z",
    fill: "#9BA4AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.443 8.60547C10.7805 8.60547 11.054 8.87901 11.054 9.21647V10.4385C11.054 10.7759 10.7805 11.0495 10.443 11.0495C10.1056 11.0495 9.83203 10.7759 9.83203 10.4385V9.21647C9.83203 8.87901 10.1056 8.60547 10.443 8.60547Z",
    fill: "#9BA4AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.55632 4.93945C5.89376 4.93945 6.16732 5.21301 6.16732 5.55046V10.4385C6.16732 10.7759 5.89376 11.0495 5.55632 11.0495C5.21886 11.0495 4.94531 10.7759 4.94531 10.4385V5.55046C4.94531 5.21301 5.21887 4.93945 5.55632 4.93945Z",
    fill: "#9BA4AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00163 6.77344C8.33908 6.77344 8.61263 7.04698 8.61263 7.38444V10.4395C8.61263 10.7769 8.33908 11.0505 8.00163 11.0505C7.66417 11.0505 7.39062 10.7769 7.39062 10.4395V7.38444C7.39062 7.04698 7.66417 6.77344 8.00163 6.77344Z",
    fill: "#9BA4AC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4433_6194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.662109)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/account-icon.bff76710bfdaf395536879233a57f001.svg";
export { ForwardRef as ReactComponent };